import { render } from "./MaterialRadio.vue?vue&type=template&id=22839765&scoped=true"
import script from "./MaterialRadio.vue?vue&type=script&lang=js"
export * from "./MaterialRadio.vue?vue&type=script&lang=js"

import "./MaterialRadio.vue?vue&type=style&index=0&id=22839765&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22839765"]])

export default __exports__